module.exports = __webpack_public_path__ + "img/Event5.71d01297.jpg";